module.exports = __webpack_public_path__ + "media/img/alufelgi@3x-4ea3733a.svg";